import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-100 dark:bg-gray-800 py-3 px-4 rounded-md my-2 w-full text-center" }
const _hoisted_2 = { class: "appFont" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = {
  key: 0,
  class: "bg-gray-100 dark:bg-gray-800 py-3 px-4 rounded-md my-2 w-full text-center"
}
const _hoisted_5 = { class: "appFont" }
const _hoisted_6 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-200" }, "KÉSZEN", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-green-200" }, "MOST", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-200" }, "READY", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-green-200" }, "NOW", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Common = _resolveComponent("Common")!

  return (_openBlock(), _createBlock(_component_Common, {
    showSheet: _ctx.showSheet,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
    title: _ctx.$t('Why is it worth subscribing?') +' 🫠'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('Benefits')) + " ⭐", 1)
      ]),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (benefit, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            (_ctx.showAllBenefits || i < 3)
              ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(benefit.short), 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(benefit.long), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAllBenefits = !_ctx.showAllBenefits)),
        class: "bg-gray-100 dark:bg-gray-800 py-3 px-4 rounded-md mt-2 w-full text-center appFont"
      }, [
        (!_ctx.showAllBenefits)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('Show more')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('Show less')), 1))
      ]),
      (_ctx.$i18n.locale == 'hu')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('buy'))),
            shrink: "",
            class: "transition duration-150 !text-white mt-3 bg-gradient-to-r from-indigo-500 via-purple-400 to-pink-500 hover:opacity-80 focus:opacity-60 block appFont rounded-lg px-3 py-2.5 w-full mx-auto text-center my-5"
          }, [
            _hoisted_9,
            _createTextVNode(" állok a frissítésre "),
            _hoisted_10
          ]))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('buy'))),
            shrink: "",
            class: "transition duration-150 !text-white mt-3 bg-gradient-to-r from-indigo-500 via-purple-400 to-pink-500 hover:opacity-80 focus:opacity-60 block appFont rounded-lg px-3 py-2.5 w-full mx-auto text-center my-5"
          }, [
            _createTextVNode(" I'm "),
            _hoisted_11,
            _createTextVNode(" to upgrade "),
            _hoisted_12
          ]))
    ]),
    _: 1
  }, 8, ["showSheet", "title"]))
}